import { render, staticRenderFns } from "./indexH5.vue?vue&type=template&id=2f94ab45&scoped=true"
import script from "./indexH5.vue?vue&type=script&setup=true&lang=ts"
export * from "./indexH5.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./indexH5.vue?vue&type=style&index=0&id=2f94ab45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94ab45",
  null
  
)

export default component.exports